import {get, post} from './Api';

export function SearchProduct({data}) {
    return post({url: '/api/v1/haire/member/search/productwarranty', data})
}

export function SearchProductById(productId) {
    return get({url: `api/v1/haire/member/search/productwarranty/infomation/${productId}`})
}

export function CreateProduct({data}) {
    return post({url: '/api/v1/haire/member/register/product', data})
}

export function CreateProductWorkOrder({data}) {
    return post({url: '/api/v1/haire/member/register/workOrder', data})
}

export function SearchProductWorkOrder({data}) {
    return post({url: '/api/v1/haire/member/search/productwarranty/workorder', data})
}



